import { createReducer } from "actionware";
import { fetchLenderRegistrations } from "./actions";
const initialState = {
    registrations: [] 
}

export default createReducer(initialState).on(fetchLenderRegistrations, (state, registrations) => {
    return {...state, registrations}
})